query ApprovalPhases {
  approvalPhases(orderBy: PHASE_NAME_ASC) {
     nodes {
       id
       phaseName
     }
}
}